function initializeThemeToggle() {
  const buttons = document.querySelectorAll(".theme-mode-toggle");
  if (!buttons.length) return;

  const root = document.documentElement;

  function setTheme(mode) {
    root.dataset.theme = mode;
    const isDark = mode === "dark";

    buttons.forEach((button) => {
      button.setAttribute("aria-pressed", String(isDark));
      button.querySelector(".theme-mode-toggle__icon").textContent =
        isDark ? "🌙" : "☀️";
    });

    try {
      localStorage.setItem("theme-mode", mode);
    } catch (error) {
      // Switching still works when browser storage is unavailable.
    }
  }

  let savedMode;
  try {
    savedMode = localStorage.getItem("theme-mode");
  } catch (error) {}

  setTheme(
    savedMode === "dark" || savedMode === "light"
      ? savedMode
      : root.dataset.theme === "dark" ? "dark" : "light"
  );

  buttons.forEach((button) => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = "true";

    button.addEventListener("click", () => {
      setTheme(root.dataset.theme === "dark" ? "light" : "dark");
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeThemeToggle);
} else {
  initializeThemeToggle();
}

document.addEventListener("shopify:section:load", initializeThemeToggle);
